import { StorageIcon } from "@/assets/icons";
import { Button } from "@/components/ui/button";
import { DialogTrigger } from "@/components/ui/dialog";

interface EmptyStateProps {
  title?: string;
  description?: string;
  buttonText?: string;
  testId?: string;
  isCreateDatasetGranted?: boolean;
  tourId?: string;
  buttonTourId?: string;
  /** When set, the CTA calls this instead of triggering the upload dialog. */
  onAddDataset?: () => void;
}

/**
 * Empty state component for when no datasets are available
 */
export default function EmptyState({
  title = "No Datasets Available",
  description = "Upload a dataset to get started.",
  buttonText = "Add Dataset",
  testId = "no-dataset-state",
  isCreateDatasetGranted = true,
  tourId,
  buttonTourId,
  onAddDataset
}: Readonly<EmptyStateProps>) {
  const addDatasetButton = (
    <Button
      variant="default"
      className="!py-[0.563rem] !px-6 !rounded-xl w-[11.25rem] my-4"
      data-tourid={buttonTourId}
      {...(onAddDataset && {
        "data-testid": "no-dataset-add-dataset-button",
        onClick: onAddDataset
      })}
    >
      {buttonText}
    </Button>
  );

  return (
    <div
      className="flex flex-col items-center justify-center h-full text-center text-sm text-dim-gray my-auto"
      data-testid={testId}
    >
      <div
        data-tourid={tourId}
        className="flex flex-col items-center justify-center w-fit h-fit"
      >
        <StorageIcon className="fill-light-gray w-8 h-8" />
        <p className="text-txtPlaceholder text-sm font-semibold">{title}</p>
        <p className="text-txtPlaceholder text-xs">{description}</p>

        {isCreateDatasetGranted &&
          (onAddDataset ? (
            addDatasetButton
          ) : (
            <DialogTrigger asChild data-testid="no-dataset-upload-button">
              {addDatasetButton}
            </DialogTrigger>
          ))}
      </div>
    </div>
  );
}
